/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: PreviewButton.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/1 @ 174
 * ---
 * Description:
 */


import {observer} from 'mobx-react';
import {HasEditor} from '../../../common/props';
import {Button, ButtonGroup, Intent} from '@blueprintjs/core';
import React, {useEffect, useState} from 'react';
import {mleDomainGqlClient} from '../../../api/domain';
import {GET_REVISION_INFO} from '../../../api/domain/queries.gql';
import {Tooltip2} from '@blueprintjs/popover2';
import {mlAuthSecured} from '../../../store/features/mylabel/auth/MyLabelAuthFeature';
import {MyLabelRevision} from "../../../entities";

interface Props extends HasEditor {
    onPreviewRequest: () => void;
    onChangeActive: () => void;
}

export const PreviewButton = observer((props: Props) => {
    const [revisionName, setRevisionName] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
            (async () => {
                setIsLoading(true);
                if (props.editor.recipeSwitcher.hasActiveRevision) {
                    const revision = await mlAuthSecured<MyLabelRevision>(props.editor, async () => {
                        return (await mleDomainGqlClient.query({
                            query: GET_REVISION_INFO,
                            variables: {
                                revisionId: props.editor.recipeSwitcher.activeRevision,
                                companyId: props.editor.recipeSwitcher.activeCompany
                            },
                            fetchPolicy: 'no-cache'
                        })).data.getLabelRevision;
                    });

                    if (revision)
                        setRevisionName(revision.recipe_name);
                }


                setIsLoading(false);
            })();
        },
        [props.editor.recipeSwitcher.activeRevision, props.editor.recipeSwitcher, props.editor.recipeSwitcher.activeCompany]);

    return (
        <ButtonGroup>
            <Button small onClick={props.onChangeActive} loading={isLoading}
                    disabled={!props.editor.mylabelAuthFeature.isConnected}>
                {
                    revisionName ? revisionName : 'Nessuna revisione attiva'
                }
            </Button>
            <Tooltip2 content="Anteprima esportazione">
                <Button small intent={Intent.PRIMARY} icon="eye-open"
                        onClick={props.onPreviewRequest}/>
            </Tooltip2>
        </ButtonGroup>
    );
});